export default __webpack_public_path__ + "static/media/300.61245738.jpg";